"use strict";
var Rules = (function () {
    function Rules() {
    }
    return Rules;
}());
exports.Rules = Rules;
//# sourceMappingURL=D:/a/1/s/eligibility/src/rules/models/rules.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/rules/models/rules.model.js